import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@/shared/services/auth.service';
import { AccountStatus } from '@/shared/models/company';
import { UserRole } from '@/shared/models/user';
import { ToastService } from '@/shared/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class InactiveAccountGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private toast = inject(ToastService);

  async canActivate(): Promise<boolean> {
    const user = this.authService.user;

    if (!user) {
      return true; // Let AuthGuard handle unauthenticated users
    }

    const accountStatus = user.company?.accountStatus;

    // Block all users from disabled accounts
    if (accountStatus === AccountStatus.Disabled) {
      this.toast.showError('This account is currently not active', false, '', true);
      this.authService.clearLocalStorage();
      this.router.navigate(['/login']);
      return false;
    }

    // Block non-admin company staff (employee + CRAT-975 lister) from any routes when the company
    // account is inactive — only an admin can act to reactivate it.
    if (
      (user.role === UserRole.employee || user.role === UserRole.lister) &&
      accountStatus === AccountStatus.Inactive
    ) {
      this.toast.showError('This account is currently not active', false, '', true);
      this.authService.clearLocalStorage();
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
